<div class="pa-bar" #wrap>
  <div class="pa-bar__legend">
    <span class="pa-bar__leg" *ngFor="let s of series"><span class="pa-bar__dot" [style.background]="s.color"></span>{{ s.label }}</span>
  </div>
  <svg [attr.viewBox]="'0 0 ' + W + ' ' + H" class="pa-bar__svg" preserveAspectRatio="xMidYMid meet">
    <defs>
      <linearGradient *ngFor="let s of series; let i = index" [attr.id]="uid + '-' + i" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" [attr.stop-color]="s.color"></stop>
        <stop offset="1" [attr.stop-color]="s.color" stop-opacity="0.7"></stop>
      </linearGradient>
    </defs>
    <rect *ngIf="highlight" class="pa-bar__hl" [attr.x]="highlight.x" [attr.y]="padT" [attr.width]="highlight.w" [attr.height]="plotH"></rect>
    <line *ngFor="let t of ticks" [attr.x1]="padL" [attr.x2]="W - padR" [attr.y1]="t.y" [attr.y2]="t.y" class="pa-bar__grid"></line>
    <line [attr.x1]="padL" [attr.x2]="W - padR" [attr.y1]="zeroY" [attr.y2]="zeroY" class="pa-bar__axis"></line>
    <text *ngFor="let t of ticks" [attr.x]="padL - 12" [attr.y]="t.y + 4" text-anchor="end" class="pa-bar__ylbl">{{ t.label }}</text>
    <path *ngFor="let b of bars" [attr.d]="b.path" [attr.fill]="'url(#' + uid + '-' + b.gi + ')'" class="pa-bar__bar"></path>
    <text *ngFor="let x of xLabels" [attr.x]="x.x" [attr.y]="H - 14" text-anchor="middle" class="pa-bar__xlbl">{{ x.label }}</text>
    <rect *ngFor="let b of bands" [attr.x]="b.x" [attr.y]="padT" [attr.width]="b.w" [attr.height]="plotH"
      fill="transparent" pointer-events="all" (mouseenter)="onEnter(b.i, $event)" (mousemove)="onMove($event)" (mouseleave)="onLeave()"></rect>
  </svg>
  <div class="pa-bar__tip" *ngIf="hoverIndex != null" [style.left.px]="tipX" [style.top.px]="tipY">
    <div class="pa-bar__tip-cat">{{ categories[hoverIndex] }}</div>
    <div class="pa-bar__tip-row" *ngFor="let r of tipRows">
      <span class="pa-bar__dot" [style.background]="r.color"></span><span class="pa-bar__tip-lbl">{{ r.label }}</span><b>{{ r.value }}</b>
    </div>
  </div>
</div>
